import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import React from "react";
import { FormTemplate } from "./templates";

const config = {
    carId: {},
    trailerId: {},
    driverId: {},
    isActive: {
        label: "Активен",
        inputProps: { name: "isActive" },
        type: "checkbox",
    },
    resourceInactivityInfo: {
        value: {
            inactivityReason: "",
            inactiveSince: "",
            inactiveUntil: "",
        },
        config: {
            inactivityReason: {
                label: "Причина",
                inputProps: { name: "inactivityReason" },
                required: true,
                validators: [(value, data) => (!data.isActive ? requiredField(value) : "")],
            },
            inactiveSince: {
                label: "Дата начала",
                inPortal: true,
                inputProps: { name: "inactiveSince" },
                required: true,
                validators: [(value, data) => (!data.isActive ? requiredField(value) : "")],
            },
            inactiveUntil: {
                label: "Дата окончания",
                inPortal: true,
                inputProps: { name: "inactiveUntil" },
                required: true,
                validators: [(value, data) => (!data.isActive ? requiredField(value) : "")],
            },
        },
    },
};
const initialState = getInitialStateFromConfig(config);

class ResourceActivityForm extends FormTemplate {
    sendRequest = ({ resourceInactivityInfo, ...stateData }) => {
        const reqData = stateData.isActive
            ? stateData
            : {
                  ...stateData,
                  resourceInactivityInfo: {
                      inactivityReason: resourceInactivityInfo.inactivityReason,
                      inactiveSince: moment(resourceInactivityInfo.inactiveSince).format("YYYY-MM-DDTHH:mm"),
                      inactiveUntil: moment(resourceInactivityInfo.inactiveUntil).format("YYYY-MM-DDTHH:mm"),
                  },
              };
        return this.props.sendReq(reqData);
    };

    onInactivityReasonChange = ({ name, value }) => {
        const { resourceInactivityInfo } = this.state;
        resourceInactivityInfo[name] = value;
        this.setState({ resourceInactivityInfo });
    };

    renderBodyInner = () => {
        const { isActive, resourceInactivityInfo } = this.props.config;
        return (
            <>
                {this.renderCheckbox(isActive)}
                {!this.state.isActive && (
                    <>
                        {this.renderField({
                            ...resourceInactivityInfo.config.inactivityReason,
                            onChange: this.onInactivityReasonChange,
                            validators: [requiredField],
                            value: this.state.resourceInactivityInfo.inactivityReason,
                        })}
                        {this.renderDateField({
                            ...resourceInactivityInfo.config.inactiveSince,
                            onChange: this.onInactivityReasonChange,
                            validators: [requiredField],
                            errorWrapper: "col-sm-8 col-md-9 offset-sm-4 offset-md-3",
                            value: this.state.resourceInactivityInfo.inactiveSince,
                        })}
                        {this.renderDateField({
                            ...resourceInactivityInfo.config.inactiveUntil,
                            onChange: this.onInactivityReasonChange,
                            validators: [requiredField],
                            errorWrapper: "col-sm-8 col-md-9 offset-sm-4 offset-md-3",
                            value: this.state.resourceInactivityInfo.inactiveUntil,
                        })}
                    </>
                )}
            </>
        );
    };
}

const ConfiguredModal = ({ initialData, ...props }) => {
    const { resourceInactivityInfo, ...rest } = initialData;
    return (
        <ResourceActivityForm
            {...props}
            config={config}
            initialState={{
                ...cloneDeep(initialState),
                ...rest,
                ...(resourceInactivityInfo ? { resourceInactivityInfo } : {}),
            }}
        />
    );
};

export default ConfiguredModal;
